var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "total-sales" }, [
    _c("div", { staticClass: "echarts-line" }, [
      _c("div", { staticClass: "card-total" }, [
        _c("div", { staticClass: "card-total-left" }, [
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v(_vm._s(_vm.baseData.total))]),
        ]),
        _c("div", { staticClass: "card-total-right" }, [
          _c("label", [_vm._v("合计")]),
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v(_vm._s(_vm.baseData.subTotal))]),
        ]),
      ]),
      _c("div", { staticClass: "card-ratio" }, [
        _c("div", { staticClass: "card-ratio-left" }, [
          _c(
            "p",
            {
              class: [
                { "data-green": _vm.baseData.increaseNum >= 0 },
                { "data-red": _vm.baseData.increaseNum < 0 },
              ],
            },
            [
              _c(
                "span",
                {
                  class: [
                    "arrow",
                    { "north-east": _vm.baseData.increaseNum >= 0 },
                    { "south-east": _vm.baseData.increaseNum < 0 },
                  ],
                },
                [
                  _c("b", {
                    class: [
                      { "el-icon-top-right": _vm.baseData.increaseNum >= 0 },
                      { "el-icon-bottom-right": _vm.baseData.increaseNum < 0 },
                    ],
                  }),
                ]
              ),
              _c("label", [_vm._v("环比增长")]),
              _vm._v(
                _vm._s(_vm.baseData.increaseNum > 0 ? "+" : "") +
                  _vm._s(_vm.baseData.increase) +
                  "% "
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "card-ratio-right" }, [
          _c("label", [_vm._v("均值")]),
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v(_vm._s(_vm.baseData.average))]),
        ]),
      ]),
    ]),
    _c("div", {
      ref: "totalSales",
      staticClass: "marketLimit",
      attrs: { id: "totalSales" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }